<template>
    <lti-drawer
        :active="active"
        :title="title"
        :refresh-on-close="refreshOnClose"
        @close="handleClose"
        @restore="loadLaunch"
        @update:active="$emit('update:active', $event)"
    >
        <div class="is-flex is-flex-direction-column is-height-full">
            <div v-if="error" class="notification is-danger is-light mb-4">
                {{ error }}
            </div>

            <div ref="ltiContainer" class="lti-resource-link-container is-flex-grow-1" />
        </div>
    </lti-drawer>
</template>

<script>
import LtiDrawer from '@/components/lti/LtiDrawer.vue';

export default {
    name: 'LtiResourceLinkDrawer',

    components: {
        LtiDrawer,
    },

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        ltiResourceLinkId: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
            default: 'LTI Tool Launch',
        },
        refreshOnClose: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['close', 'update:active'],

    data() {
        return {
            error: null,
        };
    },

    watch: {
        active(value) {
            if (value) {
                this.loadLaunch();
            } else {
                this.clearFrame();
            }
        },
        ltiResourceLinkId() {
            if (this.active) {
                this.loadLaunch();
            }
        },
    },

    mounted() {
        if (this.active) {
            this.loadLaunch();
        }
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },
        clearFrame() {
            const container = this.$refs.ltiContainer;
            if (container) {
                container.innerHTML = '';
            }
        },

        loadLaunch(payload) {
            if (payload?.relaunch === false) {
                return;
            }

            if (!this.ltiResourceLinkId) {
                this.error = 'Unable to launch this LTI tool.';
                this.clearFrame();
                return;
            }

            this.error = null;

            this.$nextTick(() => {
                const container = this.$refs.ltiContainer;
                if (!container) return;

                const launchUrl = this.buildLaunchUrl();
                const existingIframe = container.querySelector('iframe');

                if (existingIframe?.dataset?.launchUrl === launchUrl) {
                    return;
                }

                container.innerHTML = '';
                const iframe = document.createElement('iframe');
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = 'none';
                iframe.src = launchUrl;
                iframe.dataset.launchUrl = launchUrl;
                container.appendChild(iframe);
            });
        },
        buildLaunchUrl() {
            const baseUrl = import.meta.env.VITE_APP_URL;
            return `${baseUrl}/lti/links/${this.ltiResourceLinkId}`;
        },
    },
};
</script>
